import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithTwoDecimal } from '../../../components/functions'
import { useEnergiaHvacContext } from '../../../context/energiaHvacContext'
import InputMask from 'react-input-mask'

import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const energia_id = props.energia_id
    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id
    const { energiaHvac_id, setEnergiaHvac_id } = useEnergiaHvacContext()

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    const [tipo, setTipo] = useState('')
    const [marca, setMarca] = useState('')
    const [modeloEvaporadora, setModeloEvaporadora] = useState('')
    const [modeloCondensadora, setModeloCondensadora] = useState('')
    const [anoFabricacao, setAnoFabricacao] = useState('')
    const [funcao, setFuncao] = useState('')
    const [quantidade, setQuantidade] = useState('')
    const [potenciaEletrica, setPotenciaEletrica] = useState('')
    const [capacidadeRefrigeracao, setCapacidadeRefrigeracao] = useState('')
    const [cop, setCop] = useState('')
    const [fluidoRefrigerante, setFluidoRefrigerante] = useState('')
    const [ambiente, setAmbiente] = useState('')
    const [funcionamentoHorasDia, setFuncionamentoHorasDia] = useState('')
    const [funcionamentoDiasSemana, setFuncionamentoDiasSemana] = useState('')
    const [funcionamentoSemanasAno, setFuncionamentoSemanasAno] = useState('')
    const [entradaOperacao, setEntradaOperacao] = useState('')
    const [saidaOperacao, setSaidaOperacao] = useState('')

    const [listaAnos, setListaAnos] = useState()

    const [energiaAmbiente_id, setEnergiaAmbiente_id] = useState()
    const [resultadoFluidoRefrigerante, setResultadoFluidoRefrigerante] = useState()
    const [resultadoAmbientes, setResultadoAmbientes] = useState()
    const [resultadoMarcaHvac, setResultadoMarcaHvac] = useState()



    function avisoCop() {

        
        if (potenciaEletrica != '' && capacidadeRefrigeracao != '') {

            if (potenciaEletrica != '0') {

                var copCalculo = parseFloat(capacidadeRefrigeracao.replaceAll(',', '.')) * 0.293071 / parseFloat(potenciaEletrica.replaceAll(',', '.'))
                    //console.log(copCalculo)

                    setCop(copCalculo.toFixed(2).toString().replaceAll('.', ','))
                    window.toastr.info(`Conforme os valores fornecidos o COP deve ser aproximadamente <b>${copCalculo.toFixed(2).toString().replaceAll('.', ',')}</b>`)

                    /*

                    window.$.confirm({
                        //icon: 'fa fa-question',
                        theme: 'material',
                        closeIcon: true,
                        animation: 'scale',
                        type: 'orange',
                        title: 'Aviso',
                        content: `Conforme os valores fornecidos o COP deve ser aproximadamente <b>${copCalculo.toFixed(2).toString().replaceAll('.', ',')}</b>`,
                        buttons: {
                            Ok: function () {
            
                                
            
                            },
                            
            
                        },
            
                    });

                    */


                }

            }
            
            


    }



    function consultaFluidoRefrigerante() {

        api.get('fluidoRefrigeranteListaTodos').then((result) => {

            //console.log(result.data)

            setResultadoFluidoRefrigerante(result.data.map((rs) =>
            
                <option key={rs.fluidoRefrigerante_id} value={rs.descricao}>{rs.descricao}</option>
            
            ))


        }).catch((err) => {

            console.log(err.response)

        })

    }


    function carregaMarcaHvac() {


        api.get(`energiaHvacMarcaListaTodos`).then((result) => {

            //console.log(result.data)
            setResultadoMarcaHvac(result.data.map((rs) =>
            
                <option value={rs.descricao}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function carregaHvacDet() {


        if (energiaHvac_id) {


            api.get(`energiaHvacListaUm/${energiaHvac_id}`).then((result) => {

                //console.log(result.data)
                
                var data = result.data[0]

                setTipo(data.tipo)
                setMarca(data.marca)
                setModeloEvaporadora(data.modeloEvaporadora)
                setModeloCondensadora(data.modeloCondensadora)
                setAnoFabricacao(data.anoFabricacao)
                setFuncao(data.funcao)
                setQuantidade(data.quantidade == null ? '' : data.quantidade.toString())
                setPotenciaEletrica(data.potenciaEletrica == null ? '' : data.potenciaEletrica.toString())
                setCapacidadeRefrigeracao(data.capacidadeRefrigeracao == null ? '' : data.capacidadeRefrigeracao.toString())
                setCop(data.cop == null ? '' : data.cop.toString())
                setFluidoRefrigerante(data.fluidoRefrigerante == null ? '' : data.fluidoRefrigerante.toString())

                setAmbiente(data.ambiente)
                setEnergiaAmbiente_id(data.energiaAmbiente_id)
                setFuncionamentoHorasDia(data.funcionamentoHorasDia == null ? '' : data.funcionamentoHorasDia.toString())
                setFuncionamentoDiasSemana(data.funcionamentoDiasSemana == null ? '' : data.funcionamentoDiasSemana.toString())
                setFuncionamentoSemanasAno(data.funcionamentoSemanasAno == null ? '' : data.funcionamentoSemanasAno.toString())
                setEntradaOperacao(data.entradaOperacao)
                setSaidaOperacao(data.saidaOperacao)

            }).catch((err) => {

                console.log(err.response)

            })


        }


    }


    function carregaAmbientes() {

        if (energia_id) {

            api.get(`energiaAmbienteLista/${energia_id}`).then((result) => {

                //console.log(result.data)
                setResultadoAmbientes(result.data.map((rs) =>

                    <option value={rs.energiaAmbiente_id} key={rs.energiaAmbiente_id}>{rs.identificacao}</option>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }


    function limpaDados() {


        setTipo('')
        setMarca('')
        setModeloEvaporadora('')
        setModeloCondensadora('')
        setAnoFabricacao('')
        setFuncao('')
        setQuantidade('')
        setPotenciaEletrica('')
        setCapacidadeRefrigeracao('')
        setCop('')
        setFluidoRefrigerante('')
        setAmbiente('')
        setFuncionamentoHorasDia('')
        setFuncionamentoDiasSemana('')
        setFuncionamentoSemanasAno('')
        setEntradaOperacao('')
        setSaidaOperacao('')
        setResultadoAmbientes()

    }



    function carregaAnos() {

        var x_array = []

        for (var x = 1990; x <= 2030; x++) {
            
            x_array.push(x)

        }


        //console.log(x_array, 'aqui')
        setListaAnos(x_array.sort().reverse().map((ano) =>
        
            <option value={ano}>{ano}</option>
        
        ))
        

    }



    function salvaHvacUnitario() {


        if (tipo == '') {

            window.toastr.error('<b>Tipo</b> não pode ficar em branco!')
            return false

        }

        if (marca == '') {

            window.toastr.error('<b>Marca</b> não pode ficar em branco!')
            return false

        }
        

        if (cop != '') {

            if (parseFloat(cop.replaceAll(',','.')) == 0) {

                window.toastr.error('<b>COP</b> não pode ser igual a zero!')
                return false
    
            }

        }


        /*
        if (potenciaEletrica == '') {

            window.toastr.error('<b>Potência Elétrica Média [W]</b> não pode ficar em branco!')
            return false

        } else {


            if (parseInt(potenciaEletrica) == 0) {

                window.toastr.error('<b>Potência Elétrica Média [W]</b> não pode ser igual a zero!')
                return false

            }


        }
        */

        if (capacidadeRefrigeracao == '') {

            window.toastr.error('<b>Capacidade de Refrigeração</b> não pode ficar em branco!')
            return false

        } else {

            if (parseInt(capacidadeRefrigeracao) == 0) {

                window.toastr.error('<b>Capacidade de Refrigeração</b> não pode ser igual a zero!')
                return false

            }

        }


        if (anoFabricacao == '') {

            window.toastr.error('<b>Ano de Fabricação</b> não pode ficar em branco!')
            return false

        }

        if (quantidade == '') {

            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false

        } else {

            if (quantidade == '0') {

                window.toastr.error('<b>Quantidade</b> não pode ser igual a zero!')
                return false

            }

        }


        if (funcionamentoHorasDia == '') {


            window.toastr.error('<b>Funcionamento [h/dia]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoHorasDia) > 24) {

                window.toastr.error('<b>Funcionamento [h/dia]</b> não pode ser maior que 24!')
                return false

            }


        }


        if (funcionamentoDiasSemana == '') {


            window.toastr.error('<b>Funcionamento [dias/semana]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoDiasSemana) > 7) {

                window.toastr.error('<b>Funcionamento [dias/semana]</b> não pode ser maior que 7!')
                return false

            }


        }


        if (funcionamentoSemanasAno == '') {


            window.toastr.error('<b>Funcionamento [semanas/ano]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoSemanasAno) > 52) {

                window.toastr.error('<b>Funcionamento [semanas/ano]</b> não pode ser maior que 52!')
                return false

            }


        }

        if (entradaOperacao != '') {


            if (entradaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacao.split('/')
                var mesEntradaOperacao = x_array[0]

                

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                }  else {

                    var dataEntradaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')

                }


                if (anoFabricacao != '' && x_array[1] != '') {

                    var anoFabricacao_r = parseInt(anoFabricacao)

                    var anoEntradaOperacao = parseInt(x_array[1])

                    if (anoEntradaOperacao < anoFabricacao_r) {


                        window.toastr.error('O <b>Ano de entrada em operação</b> não pode ser anterior que o <b>ano de fabricação</b>!')
                        return false


                    }

                }


            }
            

        }


        if (saidaOperacao != '') {


            if (saidaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacao.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                }


                if (anoEntradaOperacao != '' && x_array[1] != '' && x_array[0] != '' && mesEntradaOperacao != '') {
                
                    var anoSaidaOperacao = parseInt(x_array[1])
                    var mesSaidaOperacao = parseInt(x_array[0])

                    if (anoSaidaOperacao < anoEntradaOperacao) {

                        window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                        return false

                    } else {

                        var dataSaidaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')
                        //console.log(dataEntradaTemp, dataSaidaTemp)

                        //console.log('aqui..')

                        if (dataSaidaTemp < dataEntradaTemp) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }

                        /*
                        if (mesSaidaOperacao < parseInt(mesEntradaOperacao)) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }
                        */


                    }


                }


            }
            

        }


        var dataPost = {

            ano: ano,
            energia_id: energia_id,
            adesao_institucional_id: adesao_institucional_id,
            tipo: tipo,
            marca: marca,
            modeloEvaporadora: modeloEvaporadora,
            modeloCondensadora: modeloCondensadora,
            anoFabricacao: anoFabricacao,
            funcao: funcao,
            quantidade: quantidade,
            potenciaEletrica: potenciaEletrica,
            capacidadeRefrigeracao: capacidadeRefrigeracao,
            cop: cop,
            fluidoRefrigerante: fluidoRefrigerante,
            ambiente: ambiente,
            funcionamentoHorasDia: funcionamentoHorasDia,
            funcionamentoDiasSemana: funcionamentoDiasSemana,
            funcionamentoSemanasAno: funcionamentoSemanasAno,
            entradaOperacao: entradaOperacao,
            saidaOperacao: saidaOperacao,
            energiaAmbiente_id: energiaAmbiente_id,

        }


        //console.log(dataPost)

        

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (energiaHvac_id) {

                        //console.log('put')

                        api.put(`energiaHvac/${energiaHvac_id}`, dataPost).then((result) => {
    
                            //setShow(false)
                            //consultaHvac()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalEnergiaHVACUnitario').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        

                        api.post('energiaHvac', dataPost).then((result) => {

                           console.log(result.data)
                            //setShow(false)
                            //consultaHvac()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalEnergiaHVACUnitario').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')

    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

        

    }



    function apagaHvac() {

        if (energiaHvac_id) {

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaHvac/${energiaHvac_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow(false)
                            //consultaHvac()

                            window.$('#modalEnergiaHVACUnitario').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }

    }


    

    useEffect(() => {

        limpaDados()
        carregaAnos()
        consultaFluidoRefrigerante()
        carregaMarcaHvac()
        carregaAmbientes()
        carregaHvacDet()

    }, [energiaHvac_id])



    const handleChange = (e) => {
        e.preventDefault();
    }



    return (

        <div>

                <div className="modal fade" id="modalEnergiaHVACUnitario" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">HVAC - Equipamento Unitário</h1>
                            </div>
                            <div className="modal-body">



                                <div className="row">

                                <div className="col-md-12" >
                                    <b>Dados básicos</b>
                                    <br/><br/>
                            </div>
                                
                                
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Tipo *</label>
                                        <select class="form-control" value={tipo} onChange={event => setTipo(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Janela">Janela</option>
                                            <option value="Split Cassete">Split Cassete</option>
                                            <option value="Split Hi-Wall">Split Hi-Wall</option>
                                            <option value="Split Piso-Teto">Split Piso-Teto</option>
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Marca *</label>
                                        <select className="form-control" value={marca} onChange={event => setMarca(event.target.value)}>
                                        
                                            <option value="">[Selecione]</option>
                                            <option value="Não informado">Não informado</option>
                                            {resultadoMarcaHvac}

                                        </select>
                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        
                                        <label className="control-label">Modelo Evaporadora</label>
                                        <input class="form-control" input="text" value={modeloEvaporadora} onChange={event => setModeloEvaporadora(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Modelo Condensadora</label>
                                        <input class="form-control" input="text" value={modeloCondensadora} onChange={event => setModeloCondensadora(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Ano de Fabricação *</label>



                                        <select class="form-control" value={anoFabricacao} onChange={event => setAnoFabricacao(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {listaAnos}
                                            <option value="0">Não informado</option>
                                        </select>
                                        
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                    <br/>
                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Função
                                                <div class="tooltip">
                                                selecione a função predominante do(s) equipamento(s).

                                                </div>
                                            </span>

                                        </label>
                                        
                                        <select class="form-control" value={funcao} onChange={event => setFuncao(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Frio">Frio</option>
                                            <option value="Quente">Quente</option>
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                    <br/>
                                        <label className="control-label">Quantidade *</label>
                                        <input class="form-control" input="text" value={quantidade} onChange={event => setQuantidade(event.target.value)} 
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }} 
                                        />
                                            
                                    </div>
                                </div>


                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Técnicos</b>
                                    <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Potência Elétrica Média [W]</label>
                                            <input class="form-control" input="text" value={potenciaEletrica} onChange={event => setPotenciaEletrica(event.target.value)} onBlur={() => avisoCop()}
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Capacidade de Refrigeração [BTU/h] *</label>
                                            <input class="form-control" input="text" value={capacidadeRefrigeracao} onChange={event => setCapacidadeRefrigeracao(event.target.value)} onBlur={() => avisoCop()}
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">COP [W/W]</label>
                                            <input class="form-control" input="text" value={cop} onChange={event => setCop(event.target.value)} 
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Fluído Refrigerante</label>
                                            <select class="form-control" value={fluidoRefrigerante} onChange={event => setFluidoRefrigerante(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {resultadoFluidoRefrigerante}
                                            </select>
                                                
                                        </div>
                                    </div>

                                    


                                    <div className="col-md-12" >
                                        <br/><br/>
                                        <b>Dados Operacionais</b>
                                        <br/><br/>
                                    </div>
                                        
                                        
                                        <div className="col-md-12" >
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Ambiente</label>
                                                <select class="form-control" value={energiaAmbiente_id} onChange={event => setEnergiaAmbiente_id(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    {resultadoAmbientes}
                                                </select>
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [h/dia] *</label>
                                                <input class="form-control" input="text" value={funcionamentoHorasDia} onChange={event => setFuncionamentoHorasDia(event.target.value)} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [dias/semana] *</label>
                                                <input class="form-control" input="text" value={funcionamentoDiasSemana} onChange={event => setFuncionamentoDiasSemana(event.target.value)} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [semanas/ano] *</label>
                                                <input class="form-control" input="text" value={funcionamentoSemanasAno} onChange={event => setFuncionamentoSemanasAno(event.target.value)} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>

                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Entrada em operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        insira a data (mês e ano) quando o equipamento entrou em operação na unidade.


                                                        </div>
                                                    </span>

                                                </label>
                                                
                                                <InputMask mask="99/9999" class="form-control" value={entradaOperacao} onChange={event => setEntradaOperacao(event.target.value)} placeholder="MM/AAAA" />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>

                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Saída de operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        Insira a data (mês e ano) quando o equipamento saiu de operação na unidade. Deixar em branco caso ainda esteja em operação.


                                                        </div>
                                                    </span>

                                                </label>
                                                
                                                <InputMask mask="99/9999" class="form-control"  value={saidaOperacao} onChange={event => setSaidaOperacao(event.target.value)} placeholder="MM/AAAA"/>
                                                    
                                            </div>
                                        </div>


                                    

                                </div>




                            </div>
                            <div className="modal-footer">


                                <button type="button" className="btn btn-danger" onClick={() => apagaHvac()} style={{ display: energiaHvac_id ? 'table-row' : 'none'}} >Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvaHvacUnitario()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal